import type { OperationRequest } from '../api/types';

export interface PendingSummary {
  count: number;
  /** Kopeks. */
  total: number;
  /** Rows awaiting approval, newest first. */
  requests: OperationRequest[];
}

/**
 * What the seller still has waiting. The whole point of the card this feeds:
 * a pending entry moves no balance, so without it the seller has no evidence
 * their entry landed — and re-types it.
 */
export function summarizePending(requests: OperationRequest[]): PendingSummary {
  const pending = requests.filter((r) => r.status === 'PENDING');
  return {
    count: pending.length,
    total: pending.reduce((sum, r) => sum + r.amount, 0),
    requests: pending,
  };
}
